import React, { PropsWithChildren, useEffect, useState } from 'react'
import { axios } from 'src/api'
import { useSentry } from 'src/hooks'
import useAuth from '../hooks/useAuth'

const AxiosInterceptorsWrapper: React.FC<PropsWithChildren> = ({
  children
}) => {
  const { captureError } = useSentry()
  const { logoutUser } = useAuth()
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    axios.interceptors.response.use(
      function (response) {
        if (
          response.data.status === 'Unauthorized' ||
          response.data.status === 'UNAUTHORIZED'
        ) {
          logoutUser()
          return Promise.reject(response.data)
        }
        if (response.data.ok === false) {
          captureError(
            { response },
            {
              description: 'error captured on useAxiosInterceptor',
              config: response.config,
              request: response.request,
              headers: response.headers
            }
          )
          return Promise.reject(response.data)
        }
        return response
      },
      function (error) {
        captureError(error, {
          description: 'error captured on useAxiosInterceptor'
        })
        return Promise.reject(error)
      }
    )
    setLoaded(true)
  }, [])

  if (!loaded) return null

  return <>{children}</>
}
export default AxiosInterceptorsWrapper
